import React, { Component } from "react"
import { Button, Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import VehicleImage from "../../../images/dashboard/diagnose-vehicle.svg"
import CardiogramImage from "../../../images/dashboard/cardiogram-logo.svg"
import { trackEvent } from "../../../shared_component/utils/segmentAnalytics"

class DiagnoseProblemCard extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { t } = this.props
    return (
      <div className="diagnose-a-problem-card">
        <div className="diagnose-a-problem-card-content">
          <p className="diagnose-a-problem-card-text">{t("havingCarTroublesMsg")}</p>
          <Button
            onClick={() => {
              trackEvent("diagnose-problem-clicked")
            }}
            href="#/diagnosis"
            className="diagnose-a-problem-card-button"
          >
            {t("diagnoseAProblemLbl")}
          </Button>
        </div>
        <div className="diagnose-a-vehicle-Images">
          <Image src={VehicleImage} className="vehicle-image" />
          <Image src={CardiogramImage} className="vehicle-cardiogram-image" />
        </div>
      </div>
    )
  }
}

export default withTranslation("justForYouCards")(DiagnoseProblemCard)
